module.exports = __webpack_public_path__ + "17b67a5cd52f2a5f3d792c4ee8abe949.svg";